import {AfterViewInit, ChangeDetectorRef, Component, NgZone} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {Router} from "@angular/router";

declare const google: any;

@Component({
    selector: "fhm-login-page",
    templateUrl: "./login-page.component.html",
    styleUrls: ["./login-page.component.scss"],
    standalone: false
})
export class LoginPageComponent implements AfterViewInit {

    constructor(private authService: AuthApiService, private router: Router, private zone: NgZone, private changeRef: ChangeDetectorRef) {
    }

    login(): void {
        this.authService.signIn().then(() => {
            if (this.authService.loginStatus()) {
                this.zone.run(() => {
                    this.router.navigate(["/main/customer-instance-venue-search"]);
                });
            } else {
                console.log("Not logged in with a chewzie.me account");
                this.authService.logout();
            }

        });
    }

    ngAfterViewInit(): void {
        const vid: HTMLVideoElement = document.getElementsByTagName("video").item(0);
        vid.muted = true;
        vid.play();
    }


}
